import { ReactComponent as Logo } from '../assets/images/arkmath_logo.svg';
import {useEffect} from "react";
import {getCookie} from "../cookie/Cookie";
import {useAuthActions} from "./auth/AuthAction";

const EmptyPage = () => {
    const { authLogoutAsync } = useAuthActions();

    useEffect(() => {
        alert("올바른 경로가 아닙니다.");
        logout();
    }, []);

    const logout = () => {
        const authCookie = getCookie("auth");

        if(authCookie){
            authLogoutAsync( authCookie )
                .then(() => {
                    window.location.href = `${process.env.REACT_APP_IS_OAUTH2_LOGOUT_URL}`;
                })
                .catch((error) => {
                    console.error("로그아웃 실패:", error);
                });
        }else{
            window.location.href = "https://aimath.i-scream.co.kr";
        }

    }


    return (
        <div className={'w-full h-[80vh] flex justify-center items-center flex-col'}>
            <Logo/>
        </div>
    );
};

export default EmptyPage;
